var _path, _circle, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.69066 0.744551L0.205221 11.6799C0.071506 11.9138 0.000754715 12.179 6.00468e-06 12.449C-0.000742706 12.7191 0.0685372 12.9847 0.200953 13.2193C0.333369 13.4539 0.524306 13.6495 0.754766 13.7864C0.985227 13.9234 1.24718 13.997 1.51456 14H14.4854C14.7528 13.997 15.0148 13.9234 15.2452 13.7864C15.4757 13.6495 15.6666 13.4539 15.799 13.2193C15.9315 12.9847 16.0007 12.7191 16 12.449C15.9992 12.179 15.9285 11.9138 15.7948 11.6799L9.30934 0.744551C9.17284 0.517264 8.98064 0.329347 8.7513 0.19893C8.52195 0.0685138 8.2632 0 8 0C7.7368 0 7.47805 0.0685138 7.2487 0.19893C7.01936 0.329347 6.82716 0.517264 6.69066 0.744551V0.744551Z",
    fill: "#FF6813"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 11,
    r: 1,
    fill: "#F7F7F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 7,
    y: 4,
    width: 2,
    height: 5,
    rx: 1,
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.ad5bdd9e70ce91f5b75f14449ab2bb22.svg";
export { ForwardRef as ReactComponent };